import React from "react"

import Icon from "../../../Icon"
import type { EntityType } from "../redux/global-map.types"
import { ENTITY_ICON_COLOR } from "./entity-icon-colors.ts"

const ENTITY_ICON_TYPE: Record<EntityType, "Projects" | "Leads"> = {
  project: "Projects",
  lead: "Leads"
}

interface EntityIconProps {
  entityType: EntityType
  // Caller-supplied size/shrink classes only (e.g. "size-6 shrink-0") — the
  // colored-square shape itself (`rounded-md`, centered content, white
  // icon) is fixed, matching the KPI row's own swatch
  // (`GlobalMapHeader.tsx`) at every call site so this reads as the SAME
  // icon everywhere, just at different scales.
  className?: string
}

/**
 * The Leads/Projects glyph+color pair the KPI row and Nearby breakdown
 * already use, packaged as one component so every other React call site
 * (search results, the List tab's Type column, the quick-view avatar,
 * Nearby rows, the marker hover tooltip) renders the identical swatch
 * rather than five hand-copied variants. The native Google Maps marker
 * (`markers.ts`, plain DOM, no React tree to mount into) uses
 * `entity-icon-colors.ts`'s raw SVG markup directly instead.
 */
const EntityIcon = ({ entityType, className }: EntityIconProps) => (
  <span
    aria-hidden="true"
    className={`flex shrink-0 items-center justify-center rounded-md text-white ${className ?? ""}`}
    style={{ backgroundColor: ENTITY_ICON_COLOR[entityType] }}
  >
    <Icon type={ENTITY_ICON_TYPE[entityType]} />
  </span>
)

export { EntityIcon }
